import React, { FC } from 'react';

import { CartButton } from 'src/shoppe/elements/CartButton';
import LogIn from 'src/prize/scenes/LogIn';

import Menu from './atoms/Menu';

import styles from './index.module.sass';

interface ButtonsProps {
  isMobile: boolean;
  onClickMenu: () => void;
}

const Buttons: FC<ButtonsProps> = ({ isMobile, onClickMenu }) => (
  <div className={styles.buttons}>
    <div className={styles.menu}>
      <Menu onClick={onClickMenu} />
    </div>

    <div className={styles.account}>
      <LogIn className={styles.login} isMobile={isMobile} />

      <CartButton className={styles.cart} />
    </div>
  </div>
);

export default Buttons;
